import { BezieApp } from "../BezieApp";
import { BObject } from "./BObject";
import { ObjSelectionHolder } from "./ObjSelectionHolder";
import { BObjectProvider } from "./Providers/BObjectProvider";

export class BObjectManager{
    private objectsProvider: BObjectProvider
    private selectedObjs: ObjSelectionHolder
    
    constructor(provider: BObjectProvider, selectedObjects: ObjSelectionHolder){
        this.objectsProvider = provider;
        this.selectedObjs = selectedObjects;
    }

    onFrameUpdate(curFrame: number){
        for( let object of this.objectsProvider.getObjects()){
            object.update(curFrame);
        }
    }

    requestDraw(canvasCtx: CanvasRenderingContext2D, playStatus: number, curFrame: number){
        for( let i = this.objectsProvider.getCount()-1; i>=0; i--){
            var obj = this.objectsProvider.getObject(i);
            if(obj){
                obj.draw(canvasCtx, playStatus!=BezieApp.PLAY_STATUS_STOP, curFrame);
            }
        }
    }

    requestResetAnimationPos(){
        for( let object of this.objectsProvider.getObjects()){
            object.resetAnimationPos();
        }
    }

    deleteSelectedObject(){
        if(!this.selectedObjs.isEmpty()){
            var countOfSelObjs = this.selectedObjs.getCountOfSelectedObjects();
            for(var i=0; i<countOfSelObjs; i++){
                var objToDel = this.selectedObjs.removeLastAddedObj();
                if(objToDel){
                    this.objectsProvider.deleteObject(objToDel);
                }
            }
        }
    }

    deleteObjectById(id: number){
        var obj = this.objectsProvider.getObjectById(id);
        if(obj){
            //Make sure the if the object being deleted is also the currently selected object, then mark this.selectedObj as null
            if(!this.selectedObjs.isEmpty() && this.selectedObjs.hasObjectWithId(obj.getId())){
                this.selectedObjs.removeObjectWithId(obj.getId());
            }
            //Find the index of the object to delete
            this.objectsProvider.deleteObject(obj);
        }
    }

    moveSelectedObjectByALayer(forward: boolean){
        if(!this.selectedObjs.isEmpty()){
            var selectedObjs = this.selectedObjs.getAllObjects();
            for(var obj of selectedObjs){
                this.moveObjByALayer(forward, obj);
            }
        }
    }

    moveObjectByALayer(forward: boolean, id: number){
        var obj = this.objectsProvider.getObjectById(id);
        if(obj){
            this.moveObjByALayer(forward, obj);
        }
    }

    private moveObjByALayer(forward : boolean, obj: BObject) : void{
        let moveBy = forward ? -1 : 1;
        let index = this.objectsProvider.getObjects().indexOf(obj, 0);
        if( (index==0 && forward) || (index==this.objectsProvider.getCount()-1 && !forward)){
            return;
        }
        this.objectsProvider.shiftBy(index, moveBy);
    }
}